var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPartyPopper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.259,
    height: 14.259,
    viewBox: "0 0 14.259 14.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "party-popper",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5898",
    "data-name": "Path 5898",
    d: "M4.267,22.335c.557.205,1.264.465,2.159.8,1.528-.213,3.133-.71,3.828-1.851C10,20.6,9.78,20,9.585,19.476A10.459,10.459,0,0,1,4.267,22.335Z",
    transform: "translate(2.854 -10.562)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5899",
    "data-name": "Path 5899",
    d: "M8.262,13.071c1.487-1.486,3.4-2.584,4.181-1.8.167.167.116.067,1.273,3.208C12.483,16.257,9.366,17.5,7.194,17.61c-.649-.244-.634-.256-.734-.357C5.5,16.3,7.306,14.027,8.262,13.071ZM7,16.713c.073.074.41.077,1.01-.219A8.452,8.452,0,0,0,10.1,14.911c1.619-1.619,2-2.91,1.8-3.1a.238.238,0,0,0-.168-.047A5.577,5.577,0,0,0,8.8,13.609,8.455,8.455,0,0,0,7.217,15.7C6.921,16.3,6.926,16.641,7,16.713Z",
    transform: "translate(-1.586 -6.394)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5900",
    "data-name": "Path 5900",
    d: "M2,26.231c.879.327,1.893.706,3.071,1.147a.381.381,0,0,0,.489-.489c-.3-.794-.564-1.512-.808-2.167A5.335,5.335,0,0,1,2,26.231Z",
    transform: "translate(8.676 -13.143)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5901",
    "data-name": "Path 5901",
    d: "M14.125,2.923a2.462,2.462,0,0,1,.622.157c-.234.358-.722.815-.423,1.411.267.533.821.5,1.3.518-.3.4-.636.812-.373,1.339.273.546.988.659,1.41.728a.253.253,0,0,0,.289-.2l.092-.5a.255.255,0,0,0-.206-.3,2.439,2.439,0,0,1-.622-.157c.235-.356.721-.817.424-1.411-.266-.532-.82-.5-1.3-.518.3-.4.636-.812.373-1.339-.273-.545-.988-.659-1.409-.728a.252.252,0,0,0-.288.2l-.092.5a.252.252,0,0,0,.2.3Z",
    transform: "translate(-8.838 -1.92)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5902",
    "data-name": "Path 5902",
    d: "M20.627,11.921l-.5.092a.252.252,0,0,0-.2.288c.069.421.182,1.136.728,1.409.527.263.935-.078,1.338-.373.017.482-.013,1.036.518,1.3.594.3,1.055-.189,1.411-.424a2.44,2.44,0,0,1,.157.622.254.254,0,0,0,.3.206l.5-.092a.252.252,0,0,0,.2-.289c-.069-.421-.182-1.136-.728-1.41-.526-.263-.935.078-1.338.373-.017-.481.015-1.035-.518-1.3-.6-.3-1.053.19-1.411.423a2.462,2.462,0,0,1-.157-.622.254.254,0,0,0-.3-.2Z",
    transform: "translate(-19.92 -6.841)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5903",
    "data-name": "Path 5903",
    d: "M23.652,20.262h.965a.152.152,0,0,0,.152-.152v-.457a.152.152,0,0,0-.152-.152h-.965a.152.152,0,0,0-.152.152v.457A.152.152,0,0,0,23.652,20.262Z",
    transform: "translate(-21.428 -10.573)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5904",
    "data-name": "Path 5904",
    d: "M25.341,2.708l.682.682a.152.152,0,0,0,.215,0l.323-.323a.152.152,0,0,0,0-.215l-.682-.682a.152.152,0,0,0-.215,0l-.323.323A.153.153,0,0,0,25.341,2.708Z",
    transform: "translate(-24.177 -2.021)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5905",
    "data-name": "Path 5905",
    d: "M11.152,5.269h.457a.152.152,0,0,0,.152-.152V4.152A.152.152,0,0,0,11.609,4h-.457A.152.152,0,0,0,11,4.152v.965A.152.152,0,0,0,11.152,5.269Z",
    transform: "translate(-2.073 -2.944)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5906",
    "data-name": "Path 5906",
    d: "M23.378,9.809l.381-.254a.153.153,0,0,0,.043-.215,7.167,7.167,0,0,0-5.148-3.086.156.156,0,0,0-.159.156v.458a.149.149,0,0,0,.145.148,6.458,6.458,0,0,1,4.533,2.754.147.147,0,0,0,.2.039Z",
    transform: "translate(-17.946 -4.054)",
    fill: "#da291c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartyPopper);
export default __webpack_public_path__ + "static/media/icon_party_popper.584bdf72225ccd18d73387d1c58281d5.svg";
export { ForwardRef as ReactComponent };